import {
  ActivityFilterKey,
  FeatureName,
  useActivityListFilter,
  useIsFeatureEnabled,
  useSetActivityListFilter,
} from '@gripp/shared-logic';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, StyleSheet } from 'react-native';
import { colors as CropCircleColors } from '../crop-circle/tokens';
import { DebouncedTextInput } from '../forms';

type ActivitySearchInputProps = {
  filterKey?: ActivityFilterKey.AssetActivity | ActivityFilterKey.Activity;
  onBlur?: () => void;
};

export const ActivitySearchInput: React.FC<ActivitySearchInputProps> = ({
  filterKey = ActivityFilterKey.Activity,
  onBlur,
}) => {
  const { t } = useTranslation();
  const isCropCircleRedesign = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  const { data: activityFilter, isLoading } = useActivityListFilter(filterKey);

  const { mutateAsync } = useSetActivityListFilter(filterKey);

  const [text, setText] = useState('');

  useEffect(() => {
    if (!text && activityFilter?.keyword) {
      setText(activityFilter.keyword);
    }
  }, [activityFilter]);

  const updateSearch = async (keyword: string) => {
    activityFilter.keyword = keyword;
    await mutateAsync(activityFilter);
  };

  return (
    activityFilter && (
      <DebouncedTextInput
        debounceTimeMs={500}
        debounceFunc={updateSearch}
        placeholder={t('activity.filter.searchPlaceholder')}
        value={text}
        onBlur={() => { if (!text && onBlur) onBlur(); }}
        onChangeText={(text) => setText(text)}
        height={isCropCircleRedesign ? 32 : 44}
        width={'100%'}
        outlineStyle={{
          ...styles.inputStyle,
          backgroundColor:
            isCropCircleRedesign || Platform.OS !== 'web'
              ? CropCircleColors.neutral[200]
              : 'white',
        }}
        disableInnerStyle={true}
        autoFocus={!isLoading && !activityFilter?.keyword}
      />
    )
  );
};

const styles = StyleSheet.create({
  inputStyle: {
    backgroundColor: CropCircleColors.neutral[200],
    borderWidth: 0,
    borderRadius: 8,
  },
});
